<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Nastavitve televizije
          </p>
        </div>
        <div v-if="seznamVsehPrikljuckov.length !== 0 && !pridobivanjePodatkov">
          <div style="padding-top: 20px" v-if="seznamVsehPrikljuckov.length > 1">
            <p>
              Izbrani priključek
              <IzbirnikPrikljuckaSelect
                style-class="izbirnik-prikljuckov"
                @novIzbranPrikljucek="izbranPrikljucek = $event"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
              />
            </p>
          </div>
          <div style="padding-top: 15px">
            <div>
              <p class="open-sans-20pt">
                Urejanje profilov in razpored TV in RA programov
              </p>
              <p style="padding-top: 16px" class="navadno-besedilo">
                Prilagodite si nastavitve in vrstni red TV ter RA programov z ustvarjanjem profilov.
                Privzeti profil je T-2 TV, za vsakega člana gospodinjstva pa lahko ustvarite svojega.
                <br/>
                Znotraj profilov lahko razporedite TV programe glede na žanr ali jezik, ustvarite pa
                lahko tudi svoj seznam programov. <br/> Več o
                <a :href="kajVseOmogocaUporabniskiProfil" target="_blank" style="cursor: pointer;
                                 text-decoration: underline" class="primarna-barva">
                  uporabniških profilih.
                </a>
              </p>
              <div style="padding-top: 20px">
                <a :href=urejanjeProfilaTv2go class="primarna-barva" target="_blank">
                  <el-button class="gumb-potrdi sirina-gumba">
                    UREDI PROFILE
                  </el-button>
                </a>
              </div>
            </div>
          </div>
          <div style="padding-top: 30px; padding-bottom: 20px;">
            <hr class="hr-stil"/>
          </div>
          <div>
            <div>
              <p class="open-sans-20pt">
                Sprememba gesla za TV profil in ogled programov za odrasle
              </p>
              <p style="padding-top: 16px" class="navadno-besedilo">
                Privzeto geslo za zaklep TV profila in ogled programov za odrasle je
                <span class="izpisGesla">
                <span v-if="prikazeIkonoNovoGeslo === false">
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i class="fa fa-circle" style="font-size:7px"></i>
                  <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashNovoGeslo"
                     @click="PrikaziGeslo(0)">
                  </i>
                </span>
              <p v-else class="odmik-znakov">
                {{ gesloVsebinaZaOdrasle }}
                <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                   @click="PrikaziGeslo(1)">
                </i>
              </p>
              </span>
              <br/>
              Spremenite ga lahko v spletni aplikaciji tv2go.
              </p>
              <div style="padding-top: 20px">
                <a :href=spremembaGeslaTv2go class="primarna-barva" target="_blank">
                  <el-button class="gumb-potrdi sirina-gumba">
                    SPREMENI GESLO
                  </el-button>
                </a>
              </div>
            </div>
          </div>
          <div v-if="podatkiPrikljucka.tip_prikljucka === 'FIX'">
            <div style="padding-top: 30px; padding-bottom: 20px;">
              <hr class="hr-stil"/>
            </div>
            <div>
              <p class="open-sans-20pt">
                Nastavitev TV PIN
              </p>
              <p style="padding-top: 16px" class="navadno-besedilo">
                Naročilo programskih shem in ostalih plačljivih storitev T-2 televizije je zaščiteno s PIN
                kodo, ki jo morate vpisati ob naročilu.<br/>
                Privzeta PIN je številka vašega priključka, lahko pa jo spremenite. PIN koda je enotna
                številka za vse televizije na priključku.
              </p>
              <div v-if="typeof this.podatkiPrikljucka !== 'undefined'">
                <div style="padding-top: 20px">
                  <el-input placeholder=""
                            class="velikost-input"
                            v-model="podatkiPrikljucka.tv_pin"
                            type="text"
                            v-loading="nalaganjePina"
                            @keyup.native="PreverjanjeStevil()"
                            maxlength="6">
                  </el-input>
                  <span class="odmik-namiga">
                  <img src="/static/img/Nastavitve/Televizija/Icon-awesome-info-circle.png"
                       class="velikost-ikone">
                  <p style="display: inline-block; padding-left: 5px">
                      Nastavitev PIN s številkami 000000 in 000001 ni možno. <br class="nova-vrstica" />
                      Nova PIN mora vsebovati 6 številk.
                  </p>
                </span>
                </div>
                <div style="padding-top: 30px">
                  <el-button type="primary" v-on:click="SpremembaTVpina"
                             class="gumb-potrdi">
                    SPREMENI PIN
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both"/>
          <div class="odmik-info-box">
            <div class="info-okvir">
              <div class="postavitev-info-icone">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="postavitev-info-tekst">
                <p class="modra-barva-info">
                  Več prilagoditev in nastavitev T-2 televizije lahko uporabniki urejajo na spletnem
                  portalu tv2go ali v nastavitvah TV vmesnika.
                <p/>
              </div>
            </div>
            <div style="clear: both"/>
          </div>
        </div>
        <div v-if="seznamPrikljuckovGrupirano.length === 0 && !pridobivanjePodatkov">
          <div class="obvestilo-prazen-seznam">
            <p>
              Na izbrani naročnini ni aktivnega TV priključka. Prosimo, izberite drugo naročnino.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {VsebinaZaOdrasleGesloEnum} from '../../../../assets/js/Enum/VsebinaZaOdrasleGesloEnum.js'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import {Input, Button, Option, Select} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PrikljucekStatusEnum} from '../../../../assets/js/Enum/PrikljucekStatusEnum'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'

export default {
  name: 'NastavitveTelevizija',
  mixins: [GetPodatkiIzbirnika],
  data () {
    return {
      title: 'Nastavitve mrežne opreme',
      clientAgent: null,
      podatkiPrikljucka: '',
      idPrikljucek: '',
      statusTVpin: '',
      prepovedaniPini: ['000000', '000001'],
      starPIN: '',
      nalaganjePina: false,
      prikazeIkonoPonoviteGeslo: true,
      prikazeIkonoNovoGeslo: false,
      spremembaGeslaTv2go: '',
      urejanjeProfilaTv2go: '',
      uporabneFunkcijeT2Televizije: '',
      kajVseOmogocaUporabniskiProfil: '',
      gesloVsebinaZaOdrasle: '',
      filter: '[tip_prikljucka]=FIX',
      selectorPermissions: ['NASTAVITVE_TELEVIZIJA'],
      seznamVsehPrikljuckov: [],
      seznamPrikljuckovGrupirano: [],
      pridobivanjePodatkov: true,
      seznamPrikljuckov: [],
      izbranPrikljucek: '',
      skupniSeznamPrikljuckov: [],
      veljavniStatusZaPrikaz: []
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [Button.name]: Button,
    [Input.name]: Input,
    [Option.name]: Option,
    [Select.name]: Select
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetPrikljucek()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.veljavniStatusZaPrikaz = [
      PrikljucekStatusEnum.VKLOPLJEN
    ]
    this.spremembaGeslaTv2go = povezave.BASE_URL_SPREMEMBA_GESLA_TV2GO
    this.urejanjeProfilaTv2go = povezave.BASE_URL_UREJANJE_PROFILA
    this.uporabneFunkcijeT2Televizije = povezave.BASE_URL_UPORABNE_FUNKCIJE_T2_TELEVIZIJE
    this.kajVseOmogocaUporabniskiProfil = povezave.BASE_URL_KAJ_VSE_OMOGOCA_UPORABNISKI_PROFIL
    this.gesloVsebinaZaOdrasle = VsebinaZaOdrasleGesloEnum.GESLO_PROGRAMI_ZA_ODRASLE
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja()
      }
    },
    GetPrikljuckiDovoljenja () {
      let param = ['permissions[]=PRIKLJUCKI']
      param.push('permissions[]=PREPAID_PRIKLJUCKI')
      this.clientAgent.postWsRequest(
        this,
        'permissions/all',
        param,
        null,
        'SetPrikljuckiDovoljenja',
        'ErrPrikljuckiDovoljenja')
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.PRIKLJUCKI.additionalData.filter(
          x => ['FIX', 'OTT'].includes(x.tip_prikljucka) && x.izklopljeneVseStoritve === '0'),
        podatki.results.PREPAID_PRIKLJUCKI.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.GetPrikljucek()
      this.pridobivanjePodatkov = false
    },
    PrikaziGeslo (status) {
      this.prikazeIkonoNovoGeslo = status === 0
    },
    GetPrikljucek () {
      for (let i = 0; i < this.seznamVsehPrikljuckov.length; i++) {
        if (this.seznamVsehPrikljuckov[i].id_prikljucek === this.izbranPrikljucek) {
          this.podatkiPrikljucka = this.seznamVsehPrikljuckov[i]
        }
      }
      this.starPIN = this.podatkiPrikljucka.tv_pin
    },
    PinValidation (pin) {
      return new RegExp(/^[0-9]{6}$/).test(pin)
    },
    PreverjanjeStevil () {
      Vue.set(this.podatkiPrikljucka, 'tv_pin', this.podatkiPrikljucka.tv_pin.replace(/[^\d]/g, ''))
    },
    SpremembaTVpina () {
      this.nalaganjePina = true
      let vpisanaDolzinaPin = this.podatkiPrikljucka.tv_pin.length
      if (vpisanaDolzinaPin !== 6) {
        if (vpisanaDolzinaPin < 6) {
          this.ShowWarningMessage({ message: 'Vpisana PIN je prekratka.' })
          this.nalaganjePina = false
        } else {
          this.ShowWarningMessage({message: 'Vpisana PIN je predolga.'})
          this.nalaganjePina = false
          return false
        }
      }
      if (!this.PinValidation(this.podatkiPrikljucka.tv_pin)) {
        let paramObvestilo = {}
        paramObvestilo.message = 'PIN mora biti dolžine 6, za PIN pa lahko uporabite samo števila.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjePina = false
      } else if (this.prepovedaniPini.includes(this.podatkiPrikljucka.tv_pin)) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nedovoljena kombinacija številk.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjePina = false
      } else if (this.starPIN === this.podatkiPrikljucka.tv_pin) {
        this.nalaganjePina = false
      } else {
        if (typeof this.podatkiPrikljucka !== 'undefined') {
          let param = ['idPrikljucek=' + this.podatkiPrikljucka.id_prikljucek]
          param.push('tvPin=' + this.podatkiPrikljucka.tv_pin)
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/spremembaTvPin',
            param,
            null,
            'SpremembaTVpinCallback',
            '')
        }
      }
    },
    SpremembaTVpinCallback () {
      if (this.starPIN !== this.podatkiPrikljucka.tv_pin) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno ste posodobili TV PIN.'
        this.ShowSuccessMessage(paramObvestilo)
      }
      this.nalaganjePina = false
    }
  }
}
</script>
<style scoped src="./../../../../../static/css/Nastavitve/Televizija/NastavitveTelevizija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelevizija.vue